var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn text-uppercase btn-sm btn-warning btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_c('li',{staticClass:"fa fa-tachometer"}),_vm._v(" Habilitar Hodômetro\n")])}
var staticRenderFns = []

export { render, staticRenderFns }